import {C240SlideStatus} from "../../utils/const";

export function checkPreviewNotDoneSlideStatus (status) {
    return status === C240SlideStatus.INITIAL
        || status === C240SlideStatus.BARCODE_ONGOING
        || status === C240SlideStatus.PREVIEW_ONGOING
        || status === C240SlideStatus.PREVIEW_IN_QUEUE
        || status === C240SlideStatus.AUTO_SCAN_IN_QUEUE;

}

export function checkInQueueSlideStatus (status) {
    return status === C240SlideStatus.BARCODE_ONGOING
        || status === C240SlideStatus.PREVIEW_ONGOING
        || status === C240SlideStatus.PREVIEW_IN_QUEUE
        || status === C240SlideStatus.SCAN_IN_QUEUE
        || status === C240SlideStatus.AUTO_SCAN_IN_QUEUE;

}